var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUncheckedSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22.0 22.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920,0 L1920,1036 L0,1036 L0,0 L1920,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,0 C19.7614237,-5.07265313e-16 22,2.23857625 22,5 L22,17 C22,19.7614237 19.7614237,22 17,22 L5,22 C2.23857625,22 3.38176876e-16,19.7614237 0,17 L0,5 C-3.38176876e-16,2.23857625 2.23857625,5.07265313e-16 5,0 L17,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1056.0 -561.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(698.0 531.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(358.0 30.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 22,0 22,22 0,22 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0 L17,0 C19.7614237,-5.07265313e-16 22,2.23857625 22,5 L22,17 C22,19.7614237 19.7614237,22 17,22 L5,22 C2.23857625,22 3.38176876e-16,19.7614237 0,17 L0,5 C-3.38176876e-16,2.23857625 2.23857625,5.07265313e-16 5,0 Z",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "none",
    strokeMiterlimit: 5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedSquare);
export default __webpack_public_path__ + "static/media/unchecked-square.36c925d1e0fe79b9ca8737afb9e41d1c.svg";
export { ForwardRef as ReactComponent };